import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createI18n } from 'vue-i18n'

// App root
import App from './App.vue'
import { mountDevBanner } from './utils/devBanner'

// Router
import router from './router'

// Stores
import { useAuthStore } from './stores/auth'

// API setup
import { setAuthStore, setRouter, setI18n } from './api/index.js'

// i18n messages
import en from '../locales/en.json'
import ko from '../locales/ko.json'

// Styles
import '../assets/styles/app.css'
import 'remixicon/fonts/remixicon.css'

// Create app
const app = createApp(App)

// Pinia
const pinia = createPinia()
app.use(pinia)

// i18n (Korean default, English fallback)
const i18n = createI18n({
    locale: 'ko',
    fallbackLocale: 'en',
    legacy: false,
    globalInjection: true,
    messages: { ko, en },
})
app.use(i18n)

// Router
app.use(router)

// Initialize auth store
const authStore = useAuthStore()

// Set API references for interceptors
setAuthStore(authStore)
setRouter(router)
setI18n(i18n)

// Mount app
app.mount('#app')
mountDevBanner() // 개발서버(id-admin.dev.wmdpass.com)에서만 상단 DEV 표시

// Initialize auth in background
authStore.initialize()
    .then(() => console.log('[Main] Auth initialization completed'))
    .catch((error) => console.error('[Main] Auth initialization failed:', error))
